/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import { Spring } from 'react-spring';
import { TimingAnimation, Easing } from 'react-spring/dist/addons';
import { Media, Card, CardBody, CardTitle, Col, Button, Form, FormGroup, Input } from 'reactstrap';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../translations/global.json"
import LanguageToggle from "./selectors/language-selector";
/** End of Multiple Language imports **/

import LanguageManager from '../custom-classes/language-manager';

// This is the item list
class PasswordReset extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en") }
        });
        this.props.addTranslation(global);
    }

    // Handles the reset password submition
    handleSubmit(e){
        e.preventDefault();
    }

    // Renders the main form, which is the reset password form
    renderForm(){
        return <div>
            <Card>
                <CardBody>
                    <CardTitle>
                        <FontAwesomeIcon icon={faEnvelope} />{' '}
                        <Translate>{({translate}) => <span>{translate("password-reset.enter-email")}</span>}</Translate>
                    </CardTitle>
                </CardBody>
                <CardBody>
                    <Form>
                        <FormGroup row>
                            <Col sm={{ size: 10, offset: 1 }}>
                                <Translate>{({translate}) =>
                                    <Input type="email" name="email" id="email" placeholder={translate("register.email")} />}
                                </Translate>
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Col sm={{ size: 10, offset: 1 }}>
                                <Button color="success" block>
                                    <Translate>{({translate}) => <span>{translate("general.submit")}</span>}</Translate>
                                </Button>
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Col sm={{ size: 10, offset: 1 }}>
                                <Link to="/" className="btn btn-info btn-block">
                                    <Translate>{({translate}) => <span>{translate("password-reset.go-back-to-login")}</span>}</Translate>
                                </Link>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Col sm={{ size: 10, offset: 1 }}>
                                <LanguageToggle/>
                            </Col>
                        </FormGroup>
                    </Form>
                </CardBody>
            </Card>
        </div>;
    };

    // Render the reset password main div
    render() {
        return(
            <Spring from={{opacity: 0}} to={{opacity: 1}} impl={TimingAnimation} config={{duration:450, easing: Easing.linear}}>
                {
                    styles => <div>
                        <Col style={styles} xs={{size: 4, offset: 4}} lg={{size: 2, offset: 5}}>
                            <Media src={require('../img/user-icon-5.png')} alt="User icon" width="100%"/>
                        </Col>
                        <Col style={styles} sm={{size: 8, offset: 2}} lg={{size:6, offset: 3}}>
                            {this.renderForm()}
                        </Col>
                        <Col style={styles} xs={{size: 4, offset: 4}} lg={{size: 2, offset: 5}}>
                            <Media style={styles} src={require('../img/logo.png')} alt="Company logo" width="100%"/>
                        </Col>
                    </div>
                }
            </Spring>
        )
    };
}

export default withLocalize(PasswordReset); // withLocaliza is added to support language. Else, don't add it.


// WEBPACK FOOTER //
// ./src/components/password-reset.js